'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AjaxCart = require('components/InlineCart/AjaxCart.js');

var dom = {
  lineItem: 'data-item-id',
  removeItem: 'data-item-remove-id',
  addItem: 'data-replace-item',
  increaseItem: 'data-item-increase-quantity',
  decreaseItem: 'data-item-decrease-quantity',
  totalAmount: 'data-cart-total-amount'
};

/**
 * Keeps track of the last removed item, so that we don't have to
 * update cart AND refetch it on clicked the "add back" button
 * (i.e. save two requests)
 */
var componentState = {};

/**
 * The time (in MS) the "add back" elements should display for before hiding
 */
var addBackLifespan = 5000;

/**
 * Update the quantity of an item in the cart
 *
 * @param {Number} itemID: the ID of the item to change
 * @param {Number} quantity: the new quantity to set
 */
var updateItemQuantity = function updateItemQuantity(itemID, quantity) {
  var lineItem = CartJS.cart.items.find(function (lineItem) {
    return lineItem.variant_id === itemID;
  }) || false;
  var updates = {};
  updates[itemID] = quantity;
  CartJS.updateItemQuantitiesById(updates).then(function (data) {
    (0, _AjaxCart.fetchInlineCart)();
    (0, _AjaxCart.fetchFullCart)();
  }).then(function () {
    var item = CartJS.cart.items.find(function (lineItem) {
      return lineItem.variant_id === itemID;
    }) || false;
    if (lineItem.discounts.length === 0 && item.discounts.length > 0) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'cartScriptApplied',
        'scriptDetails': item.discounts[0].title
      });
    } else if (lineItem.discounts.length > 0 && item.discounts.length === 0) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'cartScriptDisuse',
        'scriptDetails': lineItem.discounts[0].title
      });
    }
  });
};

/**
 * Increase the item quantity in cart by 1
 *
 * @param {Number} itemID: the ID of the item to increase
 */
var upItemQuantity = function upItemQuantity(itemID) {
  var oldQuantity = getItemQuantity(itemID);
  updateItemQuantity(itemID, oldQuantity + 1);
};

/**
 * Decrease the item quantity in cart by 1
 *
 * If the item quantity is to be 0, then use the remove fuction
 * so that we get the undo state.
 *
 * @param {Number} itemID: the ID of the item to decrease
 */
var decreaseItemQuantity = function decreaseItemQuantity(itemID) {
  var oldQuantity = getItemQuantity(itemID);
  var newQuantity = oldQuantity - 1;
  if (newQuantity > 0) {
    updateItemQuantity(itemID, oldQuantity - 1);
  } else {
    removeItem(itemID);
  }
};

/**
 * Gets how many of a variant/product are in cart based on the cart ID
 *
 * @param {Number} itemID: the variant ID of the item to remove
 *
 * @return {Number}: the quantity of the product/variant
 */
var getItemQuantity = function getItemQuantity(itemID) {
  var lineItem = CartJS.cart.items.find(function (lineItem) {
    return lineItem.variant_id === itemID;
  }) || false;
  return lineItem ? lineItem.quantity : 0;
};

/**
 * Set the total to display for the inline cart
 */
var setTotalAmountDisplay = function setTotalAmountDisplay() {
  // CartJS wasn't always returning promise, so have to manually fetch
  fetch('/cart.js').then(function (blob) {
    return blob.json();
  }).then(function (cart) {
    var totalElement = document.querySelector('[' + dom.totalAmount + ']');
    var cartTotal = (cart.total_price / 100).toFixed(2);
    totalElement.innerHTML = '$' + cartTotal;
  });
};

/**
 * Adds an item back into the cart and updates the cart
 *
 * @param {String} itemID: the ID of the item to add back in
 */
var addItem = function addItem(itemID) {
  if (!componentState[itemID]) {
    return;
  }
  var _componentState$itemI = componentState[itemID],
      quantity = _componentState$itemI.quantity,
      markup = _componentState$itemI.markup;

  CartJS.addItem(itemID, quantity, {}, {
    success: function success() {
      var addCTA = document.querySelector('[' + dom.addItem + '="' + itemID + '"]') || false;
      if (addCTA) {
        var parentNode = addCTA.parentNode;
        parentNode.insertBefore(markup, addCTA);
        parentNode.removeChild(addCTA);
        setTotalAmountDisplay();
      }
    }
  });
};

/**
 * Set's the timeout for hiding the "add back" element.
 * reloads the cart if no items are in the cart.
 *
 * @param {Node} elementToFade: the element to hide
 * @param {Number} itemID: the ID of the item to remove
 */
var setAddElementTimeout = function setAddElementTimeout(elementToFade, itemID) {
  setTimeout(function () {
    elementToFade && elementToFade.classList.add('hidden');
    if (CartJS.cart.items.length == 0 || itemID === componentState.lastItemRemoved) {
      (0, _AjaxCart.fetchInlineCart)();
      (0, _AjaxCart.fetchFullCart)();
    }
  }, addBackLifespan);
};

/**
 * Removes an item from the inline cart and adds a CTA for adding it back
 *
 * @param {Number} itemID: the variant ID of the item to remove
 */
var removeItem = function removeItem(itemID) {
  var discounts = CartJS.cart.items.map(function (item) {
    return item.discounts[0];
  });
  componentState.lastItemRemoved = itemID;
  var itemQuantity = getItemQuantity(itemID);
  var itemToRemove = CartJS.cart.items.find(function (lineItem) {
    return lineItem.id === itemID;
  });
  var cartItemsData = CartJS.cart.items.map(function (line_item) {
    return {
      item_id: line_item.id,
      shopify_product_id: line_item.id,
      shopify_variant_id: line_item.id,
      shopify_sku: line_item.sku,
      shopify_handle: line_item.handle,
      shopify_compare_price: Number(line_item.compare_at_price / 100),
      item_name: line_item.title,
      affiliation: window.theme.strings.affiliation,
      currency: window.theme.strings.general.currency_code,
      item_brand: line_item.vendor,
      item_category: line_item.type,
      item_list_id: window.bvaccel.template.name,
      item_list_name: 'cart',
      item_variant: line_item.title,
      item_featured_image: line_item.featured_image,
      option_one: line_item.option1,
      option_two: line_item.option2,
      option_three: line_item.option3,
      price: Number((line_item.price / 100).toFixed(2)),
      quantity: line_item.quantity //double check this
    };
  });
  dataLayer.push({ ecommerce: null });
  dataLayer.push({
    'event': 'acn_remove_from_cart',
    'event_id': new Date().getTime() + '.' + Math.random().toString(36).substring(5),
    ecommerce: {
      currency: window.theme.strings.general.currency_code,
      value: Number(itemToRemove.price / 100),
      items: cartItemsData
    }
  });
  CartJS.updateItemById(itemID, 0).then(function (response) {
    var toRemove = document.querySelector('[' + dom.lineItem + '="' + itemID + '"]') || false;
    if (toRemove) {
      // save element to component state to track for add back
      componentState[itemID] = {
        quantity: itemQuantity,
        markup: toRemove
        // build the "Add Back" element
      };var addElement = document.createElement('div');
      addElement.classList.add('line-item__undo');
      addElement.setAttribute(dom.addItem, itemID);
      addElement.innerHTML = itemToRemove.title + ' has been removed from your cart\n          <p class="line-item__add-back">Undo</p>';
      setAddElementTimeout(addElement, itemID);
      // add our "add back" and remove the line item
      var parentNode = toRemove.parentNode;
      parentNode.insertBefore(addElement, toRemove);
      parentNode.removeChild(toRemove);
      setTotalAmountDisplay();
    }
  }).then(function () {
    var items_discounts = CartJS.cart.items.filter(function (item) {
      return item.discounts.length;
    });
    items_discounts.map(function (item) {
      return item.discounts;
    });
    if (discounts.length > 0 && !items_discounts.length) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'cartScriptDisuse',
        'scriptDetails': discounts[0].title
      });
    }
  });
};

/**
 * Checks if an attribute is present on the target. If so, invoke the callback
 *
 * @param {Node} target: the node to check
 * @param {String} attribute: the attribute to check for
 * @param {Function} callback: the function to invoke
 */
var checkForAttribute = function checkForAttribute(target, attribute, callback) {
  var itemID = target.getAttribute(attribute) || false;
  itemID && callback(parseInt(itemID, 10));
};

/**
 * Checks if a click event was on a add/remove line item CTA
 *
 * @param {Event} event: the click event
 */
var checkUpdateLineItem = function checkUpdateLineItem(event) {
  checkForAttribute(event.target, dom.removeItem, removeItem);
  checkForAttribute(event.target, dom.addItem, addItem);
  checkForAttribute(event.target, dom.increaseItem, upItemQuantity);
  checkForAttribute(event.target, dom.decreaseItem, decreaseItemQuantity);
};

/**
 * Setup listeners for remove/add line items to and from the inline cart
 */
var setup = function setup() {
  CartJS.getCart();
  document.addEventListener('click', checkUpdateLineItem);
  document.addEventListener('keypress', checkUpdateLineItem);
};

exports.default = {
  setup: setup
};